import React from "react";
import { BaseElementProps } from "elements/types";
import { NestedViewElement } from "records/Element";
import Element from "components/Forms/Element";

function NestedForm({
	fid,
	traversal,
	rowIndex,
	disabled,
}: BaseElementProps & NestedViewElement) {
	return (
		<div className="elem elem-nestedView">
			{traversal &&
				traversal.map(uuid => {
					return (
						<Element
							rowIndex={rowIndex}
							key={uuid}
							fid={fid}
							uuid={uuid}
							disabled={disabled}
						/>
					);
				})}
		</div>
	);
}

export default React.memo(NestedForm);
